import { Appointment } from 'types/types';
import { evalAppointmentServices } from '../constants';

export const getIsEvalAppointment = (appointment: Appointment): boolean =>
  evalAppointmentServices.includes(appointment.service);
